<template>
  <div class="dashboard-pages">
    <v-card px-4 pb-4>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-card-title>
          <v-layout justify-center row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs4 pa-2 offset-xs2>
                  <v-text-field
                    v-model="updateForm.title"
                    :label="`${$t('Title')} *`"
                    name="closing_title"
                    hide-details
                    box
                    :error="errors.has('closing_title')"
                    v-validate="'required'"
                  />
                </v-flex>
                <v-flex xs2 pa-2>
                  <v-text-field
                    v-model.number="updateForm.dollarRate"
                    :label="`${$t('Dollar Rate')} *`"
                    name="dollar_price"
                    hide-details
                    box
                    :error="errors.has('dollar_price')"
                    v-validate="'required|decimal:3|min_value:0'"
                  />
                </v-flex>

                <v-flex xs2 pa-2>
                  <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                    <v-text-field
                      slot="activator"
                      :value="updateForm.date"
                      :label="`${$t('Date')} *`"
                      prepend-inner-icon="event"
                      box
                      readonly
                      hide-details
                      name="closing_date"
                      autocomplete="off"
                      :error="errors.has('closing_date')"
                      v-validate="'required|date_format:yyyy-MM-dd'"
                    />
                    <v-date-picker @change="dateMenu = false" v-model="updateForm.date" />
                  </v-menu>
                </v-flex>

                <v-flex xs8 pa-2 offset-xs2>
                  <v-textarea
                    v-model="updateForm.note"
                    :label="$t('Note')"
                    name="closing_note"
                    box
                    hide-details
                    height="80"
                    :error="errors.has('closing_note')"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs11 justify-center style="margin-top: 20px">
              <v-layout row justify-center class="form-table-header">
                <v-flex xs1 class="pa-2 form-table-content">#</v-flex>
                <!--                <v-flex xs1 class="pa-2 form-table-content">{{-->
                <!--                  $t('Code')-->
                <!--                }}</v-flex>-->
                <v-flex xs4 class="pa-2 form-table-content">{{ $t('Account Name') }}</v-flex>
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs6 class="pa-2 form-table-content">{{ $t('Debit Amount') }}</v-flex>
                    <v-flex xs6 class="pa-2 form-table-content">{{ $t('Credit Amount') }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <template v-if="rowNumbers > 0">
                <v-layout row wrap justify-center v-for="(row, index) in rowNumbers" :key="index">
                  <v-flex xs1 pa-1 style="text-align: center; margin-top: 20px; font-size: 16px">{{
                    index + 1
                  }}</v-flex>
                  <!--                  <v-flex-->
                  <!--                    xs1-->
                  <!--                    pa-1-->
                  <!--                    style="text-align: center; margin-top: 20px; font-size: 16px"-->
                  <!--                    >{{ code[index] }}</v-flex-->
                  <!--                  >-->
                  <v-flex xs4 pa-1 style="text-align: center; margin-top: 20px; font-size: 16px">{{
                    $t(account_name[index].trim())
                  }}</v-flex>

                  <v-flex xs7>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-layout row wrap v-if="!is_secondery[index]">
                          <v-flex pa-1>
                            <v-text-field
                              v-if="is_debit[index]"
                              v-model.number="amount[index]"
                              :label="`${$t('Debit')} *`"
                              hide-details
                              box
                              :readonly="is_secondery[index]"
                              :data-vv-name="'Debit' + (index + 1)"
                              :error="errors.has('Debit' + (index + 1))"
                              v-validate="'required|decimal:3|min_value:0'"
                            />
                            <v-text-field v-else :label="`${$t('Debit')}`" hide-details box disabled />
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap v-if="is_secondery[index]">
                          <v-flex xs6 pa-1>
                            <v-text-field
                              v-if="is_debit[index]"
                              v-model.number="secondAmount[index]"
                              :label="`${$t('Debit')} *`"
                              hide-details
                              box
                              :readonly="is_secondery[index]"
                              :data-vv-name="'Debit' + (index + 1)"
                              :error="errors.has('Debit' + (index + 1))"
                              v-validate="'required|decimal:3|min_value:0'"
                            />
                          </v-flex>

                          <v-flex xs6 pa-1>
                            <v-text-field
                              v-model.number="amount[index]"
                              :label="`${$t('Debit (Second Currency)')} *`"
                              hide-details
                              box
                              :data-vv-name="'Debit' + (index + 1)"
                              :error="errors.has('Debit' + (index + 1))"
                              v-validate="'required|decimal:3|min_value:0'"
                              @input="changeCurrency(index)"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6 pa-1>
                        <v-text-field
                          v-if="!is_debit[index]"
                          v-model.number="amount[index]"
                          :label="`${$t('Credit')} *`"
                          hide-details
                          box
                          :data-vv-name="'Credit' + (index + 1)"
                          :error="errors.has('Credit' + (index + 1))"
                          v-validate="'required|decimal:3|min_value:0'"
                        />
                        <v-text-field v-else :label="`${$t('Credit')}`" hide-details box disabled />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </template>

              <v-layout row justify-center class="form-table-header">
                <v-flex xs5 class="pa-2 form-table-content">
                  <strong>{{ $t('Total') }}</strong>
                </v-flex>

                <v-flex class="pa-2 form-table-content">
                  <strong>{{ totalDebit }}</strong>
                </v-flex>
                <v-flex class="pa-2 form-table-content">
                  <strong>{{ totalCredit }}</strong>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions>
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end ma-2 v-if="hasPermissions(['opening_balance_update'])">
              <v-btn type="submit" color="success" :disabled="totalCredit !== totalDebit" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions'

export default {
  name: 'opening-balance',

  data() {
    return {
      empty: 0,
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      dateMenu: false,
      rowNumbers: 0,
      updateForm: {
        title: '',
        dollarRate: 0,
        date: '',
        note: ''
      },
      code: [],
      account_id_fk: [],
      general_journal_id: [],
      account_name: [],
      debit_or_credit: [],
      is_debit: [],
      is_secondery: [],
      amount: [],
      secondAmount: [],
      totalDebit: 0,
      totalCredit: 0
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Opening Balance'),
      icon: 'fa-cogs'
    })

    this.fetchOpeningBalanceInfo()
  },

  computed: {
    ...mapGetters({
      openingBalanceInfo: 'openingBalance/getOpeningBalanceInfo'
    })
  },

  watch: {
    openingBalanceInfo: {
      immediate: false,
      handler() {
        this.rowNumbers = this.openingBalanceInfo.details.length
        this.updateForm.title = this.openingBalanceInfo.closing_title
        this.updateForm.dollarRate = this.openingBalanceInfo.dollar_price
        this.updateForm.date = this.openingBalanceInfo.closing_date
        this.updateForm.note = this.openingBalanceInfo.closing_note

        this.code = []
        this.account_id_fk = []
        this.general_journal_id = []
        this.account_name = []
        this.debit_or_credit = []
        this.is_secondery = []
        this.is_debit = []
        this.amount = []

        this.openingBalanceInfo.details.forEach(item => {
          this.code.push(item.journal_code)
          this.account_id_fk.push(item.account_id_fk)
          this.general_journal_id.push(item.general_journal_id)
          this.account_name.push(item.account_name)
          this.debit_or_credit.push(item.debit_or_credit)
          this.is_secondery.push(item.is_secondary_currency === 1)
          this.is_debit.push(item.debit_or_credit === '0')
          this.amount.push(item.amount)
        })

        for (let index = 0; index < this.amount.length; index++) {
          if (!this.is_secondery) continue

          if (this.systemCurrency === 'USD') {
            this.secondAmount[index] = Number((this.amount[index] / this.updateForm.dollarRate).toFixed(2))
          } else {
            this.secondAmount[index] = Number((this.amount[index] * this.updateForm.dollarRate).toFixed(2))
          }
        }
      }
    },

    amount: {
      deep: true,
      handler() {
        this.totalDebit = 0
        this.totalCredit = 0
        for (let index = 0; index < this.amount.length; index++) {
          if (this.is_debit[index]) {
            if (this.is_secondery[index]) {
              this.totalDebit += this.secondAmount[index]
            } else {
              this.totalDebit += this.amount[index]
            }
          } else {
            this.totalCredit += this.amount[index]
          }
        }
        this.totalDebit = Number(this.totalDebit.toFixed(2))
        this.totalCredit = Number(this.totalCredit.toFixed(2))
      }
    }
  },

  methods: {
    ...mapActions({
      fetchOpeningBalanceInfo: 'openingBalance/fetchOpeningBalanceInfo',
      updateOpeningBalanceInfo: 'openingBalance/updateOpeningBalanceInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    changeCurrency(index) {
      if (this.systemCurrency === 'USD') {
        this.secondAmount[index] = Number((this.amount[index] / this.updateForm.dollarRate).toFixed(2))
      } else {
        this.secondAmount[index] = Number((this.amount[index] * this.updateForm.dollarRate).toFixed(2))
      }
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)

            this.general_journal_id.forEach((p, index) => {
              formData.append('general_journal_id[' + [index] + ']', p)
            })

            this.account_id_fk.forEach((p, index) => {
              formData.append('account_id_fk[' + [index] + ']', p)
            })

            this.debit_or_credit.forEach((q, index) => {
              formData.append('debit_or_credit[' + [index] + ']', q)
            })

            this.amount.forEach((p, index) => {
              formData.append('amount[' + [index] + ']', p)
            })

            this.updateOpeningBalanceInfo(formData)
              .then(() => {
                this.btnUpdateLoading = false
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped />
